import React, { useEffect, useMemo, useState } from 'react';
import { Grid, TextField, Typography, Button } from '@mui/material';
import Skeleton from '@material-ui/lab/Skeleton';
import Cookies from 'js-cookie';
import api from '../../../../../services/api';

export default function GerenciarReserva({ reserva, idOrdemServico, idOrdemCompra }) {

    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode');
        return saved === 'true';
    });

    const themeHelper = {
        bg: darkMode ? "#252525" : "#e9eff3",
        paper: darkMode ? "#2e2e2e" : "#f5f8fa",
        text: darkMode ? "#ffffff" : "#1a1a1a",
        border: darkMode ? "#444444" : "#d1d9e0",
    };

    useEffect(() => {
        const checkDarkMode = () => {
            const saved = Cookies.get('darkMode');
            setDarkMode(saved === 'true');
        };

        window.addEventListener('darkModeChanged', checkDarkMode);
        window.addEventListener('focus', checkDarkMode);

        return () => {
            window.removeEventListener('darkModeChanged', checkDarkMode);
            window.removeEventListener('focus', checkDarkMode);
        };
    }, []);


    const [loading, setLoading] = useState(true);
    const [infoEstoque, setInfoEstoque] = useState([]);

    console.log("Id ordem compra recebido: " + idOrdemCompra);

    // ===============================
    // BUSCA ESTOQUE
    // ===============================
    async function consultarEstoqueItem() {
        try {
            const headers = {
                Authorization: 'Bearer ' + Cookies.get('token')
            };

            const insumo = reserva?.insumo;
            const idInsumo =
                insumo?.id_insumo > 0
                    ? insumo.id_insumo
                    : insumo?.insumo?.id_insumo;

            console.log('🔎 ID INSUMO:', idInsumo);

            const response = await api.get(
                `/v1/protected/almoxarifado/estoque/listarporinsumosrapidoporid/${idInsumo}`,
                { headers }
            );

            console.log('📦 RESPONSE ESTOQUE:', response.data);

            setInfoEstoque(response.data || []);
            setLoading(false);

        } catch (e) {
            console.error('❌ ERRO AO BUSCAR ESTOQUE', e);
            setLoading(false);
        }
    }

    useEffect(() => {
        consultarEstoqueItem();
        // eslint-disable-next-line
    }, []);

    // ===============================
    // AGRUPAMENTO COM DEBUG
    // ===============================
    const estoquePorUnidade = useMemo(() => {
        console.log('🧮 INFO ESTOQUE BRUTO:', infoEstoque);

        const mapa = {};

        infoEstoque.forEach((registro, idx) => {
            console.log(`➡️ REGISTRO ${idx}:`, registro);

            (registro.itens_estoque || []).forEach((item, i) => {
                console.log(`   📦 ITEM ${i}:`, item);

                const idArm =
                    item.id_armazenamento ??
                    item.armazenamento?.id_armazenamento;

                console.log('      🏷️ ID ARMAZENAMENTO:', idArm);

                const unidade =
                    item.descricao_armazenamento ??
                    item.armazenamento?.descricao ??
                    'INDEFINIDO';

                console.log('      🏢 UNIDADE:', unidade);

                if (!idArm) {
                    console.warn('      ⚠️ ITEM IGNORADO (SEM ID ARMAZENAMENTO)');
                    return;
                }

                if (!mapa[idArm]) {
                    mapa[idArm] = {
                        idArmazenamento: idArm,
                        unidade,
                        disponivel: 0,
                        reservado: 0
                    };
                }

                if (item.status_item === 0) {
                    mapa[idArm].disponivel++;
                    console.log('      ✅ DISPONÍVEL +1');
                }

                const isReservaOS =
                    idOrdemServico &&
                    item.id_ordem_servico_reservada === idOrdemServico;

                const isReservaOC =
                    idOrdemCompra &&
                    item.id_ordem_compra_reservado === idOrdemCompra;

                if (item.status_item === 1 && (isReservaOS || isReservaOC)) {
                    mapa[idArm].reservado++;
                    console.log('      🔒 RESERVADO +1');
                }

            });
        });

        console.log('📊 MAPA FINAL:', mapa);

        return Object.values(mapa);
    }, [infoEstoque, idOrdemServico, idOrdemCompra]);

    // ===============================
    // ATUALIZA RESERVA
    // ===============================
    async function atualizarReserva(idArmazenamento, quantidade) {
        try {
            const headers = {
                Authorization: 'Bearer ' + Cookies.get('token')
            };

            console.log('🟡 ATUALIZAR RESERVA:', {
                idArmazenamento,
                quantidade
            });

            if (idOrdemServico) {
                await api.put(
                    `/v1/protected/ordemservico/${idOrdemServico}` +
                    `/editarrequerimento/atualizaritempeloestoque/quantidadereservada/` +
                    `${reserva.id_item_requerimento}/${idArmazenamento}`,
                    { quantidade_reservada: quantidade },
                    { headers }
                );
            } else if (idOrdemCompra) {
                await api.put(
                    `/v1/protected/ordensdecompras/${idOrdemCompra}` +
                    `/editarrequerimento/atualizaritempeloestoque/quantidadereservada/` +
                    `${reserva.id_item_requerimento}/${idArmazenamento}`,
                    { quantidade_reservada: quantidade },
                    { headers }
                );
            }

            consultarEstoqueItem();

        } catch (e) {
            console.error('❌ ERRO AO ATUALIZAR RESERVA', e);
            alert(e.response?.data || 'Erro ao atualizar reserva');
        }
    }

    if (loading) {
        return <Skeleton height={200} />;
    }

    return (
        <Grid container spacing={2}>

            {/* RESUMO */}
            <Grid item xs={12}>
                <Typography style={{ color: themeHelper.text }}>
                    <strong>Qtd Pedida:</strong> {reserva.quantidade} &nbsp; | &nbsp;
                    <strong>Qtd Reservada:</strong> {reserva.quantidade_reservada} &nbsp; | &nbsp;
                    <strong>Qtd a Comprar:</strong> {reserva.quantidade_a_comprar}
                </Typography>
            </Grid>


            {/* TABELA */}
            <Grid item xs={12}>
                <table style={{ width: '100%', borderCollapse: 'collapse', color: themeHelper.text }}>
                    <thead>
                        <tr style={{ backgroundColor: darkMode ? '#333' : '#f5f5f5' }}>
                            <th style={{ border: `1px solid ${themeHelper.border}`, padding: '8px', color: darkMode ? '#fff' : themeHelper.text }}>Unidade</th>
                            <th style={{ border: `1px solid ${themeHelper.border}`, padding: '8px', color: darkMode ? '#fff' : themeHelper.text }}>Disponível</th>
                            <th style={{ border: `1px solid ${themeHelper.border}`, padding: '8px', color: darkMode ? '#fff' : themeHelper.text }}>Qtd Reservada</th>
                            <th style={{ border: `1px solid ${themeHelper.border}`, padding: '8px', color: darkMode ? '#fff' : themeHelper.text }}>Ação</th>
                        </tr>
                    </thead>

                    <tbody>
                        {estoquePorUnidade.map(u => (
                            <LinhaReserva
                                key={u.idArmazenamento}
                                unidade={u}
                                atualizar={atualizarReserva}
                                darkMode={darkMode}
                            />
                        ))}
                    </tbody>
                </table>
            </Grid>
        </Grid>
    );
}

// ===============================
// LINHA
// ===============================
function LinhaReserva({ unidade, atualizar, darkMode }) {

    const themeHelper = {
        border: darkMode ? "#444444" : "#d1d9e0",
    };

    const [valor, setValor] = useState(unidade.reservado);
    const [alterado, setAlterado] = useState(false);

    useEffect(() => {
        console.log('🔄 ATUALIZA LINHA:', unidade);
        setValor(unidade.reservado);
        setAlterado(false);
    }, [unidade]);

    const maxPermitido = unidade.disponivel + unidade.reservado;

    return (
        <tr style={{ borderBottom: `1px solid ${themeHelper.border}` }}>
            <td style={{ padding: '8px', border: `1px solid ${themeHelper.border}` }}>{unidade.unidade}</td>
            <td style={{ padding: '8px', border: `1px solid ${themeHelper.border}`, textAlign: 'center' }}>{unidade.disponivel}</td>
            <td style={{ padding: '8px', border: `1px solid ${themeHelper.border}` }}>

                <TextField
                    type="number"
                    size="small"
                    value={valor}
                    inputProps={{ min: 0, max: maxPermitido }}
                    onChange={e => {
                        let v = parseInt(e.target.value, 10) || 0;
                        if (v < 0) v = 0;
                        if (v > maxPermitido) v = maxPermitido;
                        setValor(v);
                        setAlterado(true);
                    }}
                />
            </td>
            <td style={{ padding: '8px', border: `1px solid ${themeHelper.border}`, textAlign: 'center' }}>
                <Button
                    variant="contained"
                    size="small"
                    disabled={!alterado}
                    onClick={() =>
                        atualizar(unidade.idArmazenamento, valor)
                    }
                >
                    Aplicar
                </Button>
            </td>
        </tr>

    );
}
